// --- Configuration ---
var registrationServerHost = "https://clutch-customers-followup.vercel.app";
var registrationFormWebhook = "/form"; 
var salesPersonsWebhook = "/salespersons";
var registrationRequestUrl = registrationServerHost + registrationFormWebhook;

// --- DOM Selection and Initial Setup ---
var title = document.querySelector('#MainContent > div > header');
var form = document.querySelector('form#create_customer'); // Use form ID for selection
var passwordInputs = form ? form.querySelectorAll('input[type=password]') : [];
for (let i = 0; i < passwordInputs.length; i++) {
    if (passwordInputs[i].parentElement) {
       passwordInputs[i].parentElement.remove();
    }
}
var submitButton = form ? form.querySelector('button#register-submit, button[type=submit], input[type=submit]') : null; // Target button by ID or type
var parentDiv = document.createElement('div');
var returnMessageDiv = document.createElement('div');
parentDiv.classList.add('ev_parent_return_message');
returnMessageDiv.classList.add('ev_return_message');
returnMessageDiv.style.cssText = `background: #000; z-index: 999; text-align: center; padding: 15px; border-radius: 5px; position: fixed; transition: bottom 0.4s ease-out; color: white; font-weight: 600; bottom: -100px;`;
parentDiv.appendChild(returnMessageDiv);
document.body.appendChild(parentDiv);

if (submitButton) {
    submitButton.type = "button"; // Ensure it doesn't submit natively
    submitButton.addEventListener("click", handleFormSubmit);
} else {
    console.error("Submit button not found for the registration form (#create_customer).");
}

// --- Main Form Submission Handler ---
async function handleFormSubmit(e) {
    if (!form) {
        console.error("Registration form (#create_customer) not found.");
        return;
    }
    if (!submitButton) {
        console.error("Submit button reference lost.");
        return;
    }
    submitButton.disabled = true;

    // Show loading indicator
    var loadingDiv = document.createElement('div');
    loadingDiv.innerHTML = `<span style="border: 6px solid #ffffff; border-radius: 50%; border-top: 6px solid #000000; width: 50px; height: 50px; -webkit-animation: spin 2s linear infinite; animation: spin 1s linear infinite;"></span>`;
    loadingDiv.style.cssText = `position: fixed; background: rgba(0,0,0,0.5); width: 100%; height: 100%; top: 0; left: 0; color: white; z-index: 999; display: flex; align-items: center; justify-content: center;`;
    document.body.appendChild(loadingDiv);

    // --- Data Preparation ---
    var formData = new FormData(form);
    var jsonPayload = {};

    formData.forEach(function(value, key) {
        jsonPayload[key] = value;
    });

    // **IMPORTANT**: Handle Checkboxes specifically
    // Email Consent Checkbox (position in HTML doesn't matter for JS)
    const consentCheckbox = document.getElementById('marketing_consent_checkbox'); // Use document.getElementById for reliability
    jsonPayload['emailConsent'] = consentCheckbox ? consentCheckbox.checked : false; // Send boolean true/false

    // **IMPORTANT**: Handle Training Interested dropdown value
    // The value from the <select> is already captured by FormData
    // formData.forEach sets jsonPayload['trainingInterested'] = "true" or "false" (as strings)
    // The backend function needs to handle these string values appropriately (e.g., String(value).toLowerCase() === 'true')
    // So, no extra JS is needed here for the trainingInterested select dropdown, FormData handles it.

    // Remove hidden fields or submit button values if they were included by FormData
    delete jsonPayload['form_type'];
    // If the button had a name attribute, remove it: delete jsonPayload['buttonName'];

    console.log("Sending payload:", JSON.stringify(jsonPayload));
    console.log("Sending request to:", registrationRequestUrl);
    // --- API Call ---
    try {
        const response = await fetch(registrationRequestUrl, {
            method: "POST",
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(jsonPayload)
        });

        if (!response.ok) {
            let errorData;
            try {
                errorData = await response.json();
            } catch (parseError) {
                console.error("Could not parse error response:", parseError);
                insertMessage(`<div class="error_box" style="margin-bottom: 10px; border: 1px solid red; padding: 10px;"><p style="color: red;">An unexpected error occurred (Status: ${response.status} ${response.statusText}). Please try again later or contact support.</p></div>`);
                return;
            }
            const message = errorData?.htmlMessage || `<div class="error_box" style="margin-bottom: 10px; border: 1px solid red; padding: 10px;"><p style="color: red;">An error occurred (Status: ${response.status}). Please check your input and try again.</p></div>`;
            insertMessage(message);

        } else {
            const resData = await response.json();
            console.log("API Response:", resData);

            if (resData.status === 200) {
                if(form) form.remove();
                insertMessage(resData.htmlMessage, false);
            } else {
                insertMessage(resData.htmlMessage || '<div class="error_box" style="margin-bottom: 10px; border: 1px solid red; padding: 10px;"><p style="color: red;">An unknown issue occurred. Please check your details.</p></div>');
            }
        }

    } catch (error) {
        console.error('Error sending data:', error);
        insertMessage('<div class="error_box" style="margin-bottom: 10px; border: 1px solid red; padding: 10px;"><p style="color: red;">A network error occurred. Please check your connection and try again, or <a href="https://clutchhairculture.com/pages/contact-us" target="_blank">contact us</a>.</p></div>', false);
    } finally {
      if (loadingDiv) loadingDiv.remove();
      if (submitButton) submitButton.disabled = false;
    }
}

// --- Utility Functions ---
function removeMessage(msg_id){
  const message_ele = document.getElementById(msg_id);
  if (message_ele) {
    message_ele.remove();
  }
}

var last_msg_id;

function insertMessage(value, hide=true) {
  if (!title) {
      console.error("Title element not found for inserting messages.");
      return;
  }
  removeMessage(last_msg_id);

  const msg_id = "message_"+makeid(5);
  last_msg_id = msg_id;
  // Insert message *after* the header element
  title.insertAdjacentHTML("afterend", `<div id="${msg_id}" class="form-message-container">${value}</div>`);
  window.scrollTo({ top: 0, behavior: 'smooth' });

  if (hide){
    const hideDelay = Math.max(8000, value.length * 20);
    setTimeout(() => removeMessage(msg_id), hideDelay);
  }
}

function returnCall(value, color, elemToRemove) {
    returnMessageDiv.style.bottom = "70px";
    returnMessageDiv.style.background = color;
    returnMessageDiv.innerHTML = value;
    if (elemToRemove) elemToRemove.remove();
    setTimeout(hideReturnCall, 3000);
}
function hideReturnCall() {
    returnMessageDiv.style.bottom = "-100px";
}

function makeid(length) {
    let result = '';
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const charactersLength = characters.length;
    for (let i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
}

function fetchOptions() {
  fetch(registrationServerHost + salesPersonsWebhook)
    .then(response => {
        if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
        return response.json();
     })
    .then(data => {
      const selectElement = document.getElementById('refferedBy');
      if (!selectElement) {
          console.error("Dropdown #refferedBy not found.");
          return;
      }
      const options = ["No", ...data];
      options.forEach(optionText => {
        const optionElement = document.createElement('option');
        optionElement.value = optionText;
        optionElement.textContent = optionText;
        selectElement.appendChild(optionElement);
      });
    })
    .catch(error => console.error('Error fetching options:', error));
}

// --- Initialization ---
document.addEventListener("DOMContentLoaded", function() {
    // Re-select form and button potentially after dynamic changes or script loading order issues
    form = document.querySelector('form#create_customer');
    submitButton = form ? form.querySelector('button#register-submit, button[type=submit], input[type=submit]') : null;

    if (form && submitButton) {
        fetchOptions(); // Fetch options only if form exists
        if (submitButton.type !== "button") {
            submitButton.type = "button";
        }
         // Check if listener already exists might be overly complex; simply ensure it's attached once
         // If the button element isn't replaced, the initial listener should remain.
         // If issues arise, consider adding logic to remove/re-add listener here.
    } else {
         if (!form) console.error("Form #create_customer not found on DOMContentLoaded.");
         if (!submitButton) console.error("Submit button not found on DOMContentLoaded.");
    }
});